module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-review"
    }
  }, [_c('v-card', {
    staticClass: "my-3",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-list-item', [_c('v-list-item-title', {
    staticClass: "text-subtitle-2 font-weight-bold"
  }, [_vm._v("\n                Kode Tryout\n            ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                " + _vm._s(_vm.$store.state.tryout.code) + "\n            ")])], 1), _vm._v(" "), _c('v-list-item', {
    staticStyle: {
      "background-color": "#fbfbfb"
    }
  }, [_c('v-list-item-title', {
    staticClass: "text-subtitle-2 font-weight-bold"
  }, [_vm._v("\n                Nama Tryout\n            ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                " + _vm._s(_vm.$store.state.tryout.name) + "\n            ")])], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-item-title', {
    staticClass: "text-subtitle-2 font-weight-bold"
  }, [_vm._v("\n                Jenis Tryout\n            ")]), _vm._v(" "), (_vm.$store.state.tryout.is_repeated) ? _c('v-list-item-subtitle', [_vm._v("\n                INSTANT\n            ")]) : _c('v-list-item-subtitle', [_vm._v(" BERJANGKA ")])], 1), _vm._v(" "), _c('v-list-item', {
    staticStyle: {
      "background-color": "#fbfbfb"
    }
  }, [_c('v-list-item-title', {
    staticClass: "text-subtitle-2 font-weight-bold"
  }, [_vm._v("\n                Jenjang Tryout\n            ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                " + _vm._s(_vm.$store.state.tryout.level) + " /\n                " + _vm._s(_vm.$store.state.tryout.type) + "\n            ")])], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-item-title', {
    staticClass: "text-subtitle-2 font-weight-bold"
  }, [_vm._v("\n                Durasi\n            ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                " + _vm._s(_vm.$store.state.tryout.duration) + " menit\n            ")])], 1), _vm._v(" "), _c('v-list-item', {
    staticStyle: {
      "background-color": "#fbfbfb"
    }
  }, [_c('v-list-item-title', {
    staticClass: "text-subtitle-2 font-weight-bold"
  }, [_vm._v("\n                Opsi\n            ")]), _vm._v(" "), (_vm.$store.state.tryout.is_free_access) ? _c('v-list-item-subtitle', [_vm._v("\n                Akses Gratis\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.tryout.is_repeated) ? _c('v-list-item-subtitle', [_vm._v("\n                Tryout Berulang\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-item-title', {
    staticClass: "text-subtitle-2 font-weight-bold"
  }, [_vm._v("\n                Mulai\n            ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                " + _vm._s(_vm.$store.state.tryout.start_date.value) + "\n                " + _vm._s(_vm.$store.state.tryout.start_time.value) + "\n            ")])], 1), _vm._v(" "), _c('v-list-item', {
    staticStyle: {
      "background-color": "#fbfbfb"
    }
  }, [_c('v-list-item-title', {
    staticClass: "text-subtitle-2 font-weight-bold"
  }, [_vm._v("\n                Berakhir\n            ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                " + _vm._s(_vm.$store.state.tryout.end_date.value) + "\n                " + _vm._s(_vm.$store.state.tryout.end_time.value) + "\n            ")])], 1), _vm._v(" "), _c('v-list-item', {
    staticStyle: {
      "background-color": "#fbfbfb"
    }
  }, [_c('v-list-item-title', {
    staticClass: "text-subtitle-2 font-weight-bold"
  }, [_vm._v("\n                Status Tryout\n            ")]), _vm._v(" "), _c('v-list-item-subtitle', [(_vm.$store.state.tryout.status == 'DRAFT') ? _c('v-btn', {
    staticClass: "dark--text",
    attrs: {
      "elevation": "0",
      "small": "",
      "color": "#F5F7FA"
    }
  }, [_vm._v("\n                    Draft\n                ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.tryout.status == 'REVIEW') ? _c('v-btn', {
    staticClass: "darkYellow--text",
    attrs: {
      "elevation": "0",
      "small": "",
      "color": "backgroundYellow"
    }
  }, [_vm._v("\n                    Review\n                ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.tryout.status == 'PUBLISHED') ? _c('v-btn', {
    staticClass: "darkGreen--text",
    attrs: {
      "elevation": "0",
      "small": "",
      "color": "backgroundGreen"
    }
  }, [_vm._v("\n                    Publish\n                ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "pa-0 mt-3 ma-0",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "text-subtitle-1 font-weight-bold"
  }, [_vm._v("\n                Subtest\n            ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-0 pt-0 pb-2 ma-0"
  }, _vm._l((_vm.$store.state.tryout.subtests), function(subtest, index) {
    return _c('v-card', {
      key: subtest.id,
      staticClass: "my-2",
      attrs: {
        "flat": ""
      }
    }, [_c('v-list', {
      staticClass: "pa-2"
    }, [
      [_c('v-list-item', {
        attrs: {
          "two-line": ""
        }
      }, [_c('span', {
        staticClass: "roboto-text font-weight-bold mt-3",
        staticStyle: {
          "top": "0 !important",
          "position": "absolute"
        }
      }, [_vm._v(_vm._s(index + 1) + ".    \n                                ")]), _vm._v(" "), _c('v-list-item-avatar', {
        staticClass: "mx-2 my-0"
      }, [_c('v-img', {
        attrs: {
          "src": subtest.subject_picture,
          "width": "45px"
        }
      })], 1), _vm._v(" "), _c('v-list-item-content', {
        staticClass: "pa-0"
      }, [_c('v-list-item-title', {
        staticClass: "font-weight-bold"
      }, [_vm._v("\n                                        " + _vm._s(subtest.subject_name) + "\n                                        "), _c('v-badge', {
        staticClass: "mx-2",
        attrs: {
          "color": "#ECEFF5"
        },
        scopedSlots: _vm._u([{
          key: "badge",
          fn: function() {
            return [_c('span', {
              staticClass: "darkFade--text"
            }, [_vm._v("\n                                                    " + _vm._s(subtest.duration) + "m\n                                                ")])]
          },
          proxy: true
        }], null, true)
      })], 1), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                                        " + _vm._s(subtest.details.length) + " Soal\n                                    ")])], 1)], 1)]
    ], 2)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "depressed": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('uncompleted')
      }
    }
  }, [_vm._v("\n                Kembali\n            ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "color": "blew",
      "type": "button",
      "depressed": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('completed')
      }
    }
  }, [_vm._v("\n                Selesai\n            ")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "506px"
    },
    model: {
      value: (_vm.dialogConfirm.open),
      callback: function($$v) {
        _vm.$set(_vm.dialogConfirm, "open", $$v)
      },
      expression: "dialogConfirm.open"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5",
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.dialogConfirm.title) + "\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                " + _vm._s(_vm.dialogConfirm.subtitle) + "\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirm.open = false
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), (_vm.dialogConfirm.function == 'DRAFT') ? _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": _vm.confirmDraft
    }
  }, [_vm._v("\n                    OK\n                ")]) : _vm._e(), _vm._v(" "), (_vm.dialogConfirm.function == 'REVIEW') ? _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": _vm.confirmReview
    }
  }, [_vm._v("\n                    OK\n                ")]) : _vm._e(), _vm._v(" "), (_vm.dialogConfirm.function == 'PUBLISH') ? _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": _vm.confirmPublish
    }
  }, [_vm._v("\n                    OK\n                ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63a59ef2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tryout/components/Review.vue
// module id = 2096
// module chunks = 1